/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "d21281e430b1a2eaccdcb07be9a76891aedb4856";
